// System message bubble: out-of-band notices from the controller (rate
// limit, cap-blocked, session-not-found, cancelled, network error, hit
// max iterations). Distinct from the assistant role — these aren't from
// the model, they're status from the runtime.
//
// Required because assistant-ui's default `SystemMessage` is `() => null`,
// which silently swallowed every status message before we wired this in.
//
// Variants:
//   - "granted" pill (green): text starts with ✓ — control-granted /
//     guide-step-done breadcrumbs. Calls out a positive confirmation.
//   - "denied" pill (purple): text starts with ✕ — control-denied
//     breadcrumb ("Just guiding — you'll click").
//   - default muted card: everything else (errors, rate limits, etc.).
// Pill design lifted from kyoto-client-side-only-prototype-v2.js § cua-perm-breadcrumb.

import React from "react";
import { MessagePrimitive } from "@assistant-ui/react";

function variantFor(text) {
  if (!text) return "default";
  if (text.startsWith("✓")) return "granted";
  if (text.startsWith("✕")) return "denied";
  return "default";
}

const VARIANT_CLASS = {
  granted: "copilot-breadcrumb copilot-breadcrumb--granted",
  denied:  "copilot-breadcrumb copilot-breadcrumb--denied",
  default: "copilot-system-message tw-max-w-[90%] tw-rounded-md tw-border tw-border-border tw-bg-muted tw-px-3 tw-py-1.5 tw-text-xs tw-text-muted-foreground tw-shadow-sm",
};

function VariantPart({ text }) {
  const variant = variantFor(text);
  const className = `${VARIANT_CLASS[variant]} tw-whitespace-pre-wrap tw-break-words`;
  return (
    <span role="status" className={className}>
      {text}
    </span>
  );
}

export function SystemMessage() {
  return (
    <MessagePrimitive.Root className="tw-flex tw-w-full tw-justify-center tw-py-1">
      <MessagePrimitive.Content
        components={{
          Text: VariantPart,
        }}
      />
    </MessagePrimitive.Root>
  );
}
